import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"; // импорт хука авторизации
import AppProps from "../../static/js/AppProps";

const ProductsBased = ({ category, subcategory, products = [] }) => {
    const { user, loading } = useAuth(); // получаем user и loading из контекста
    useNavigate();

    const filteredProducts = products.filter(product => {
        if (!category) return true;
        if (subcategory) {
            return product.category === category && product.subcategory === subcategory;
        }
        return product.category === category;
    });

    if (loading) {
        return <p>Загрузка данных пользователя...</p>;
    }

    if (filteredProducts.length === 0) {
        return (
            <p style={{ padding: 16 }}>
                Товары не найдены для категории <b>{category}</b>
                {subcategory && <span> и подкатегории <b>{subcategory}</b></span>}.
            </p>
        );
    }

    return (
        <section className="pricing03 cid-uLnVhX2M9H" id={`pricing03-${category.replace(/\s/g, "")}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 content-head">
                        <div className="mbr-section-head mb-5">
                            <h5 className="mbr-section-subtitle mbr-fonts-style align-center mt-4 mb-0 display-5">
                                <strong>{category}</strong>
                                {subcategory && <> — {subcategory}</>}
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {filteredProducts.map(product => (
                        <ProductCard key={product?.id || Math.random()} product={product} user={user} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const ProductCard = ({ product, user }) => {
    const [showLayers, setShowLayers] = useState(false);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [isSuccessMessage, setIsSuccessMessage] = useState(false);
    const [isAlreadyInCart, setIsAlreadyInCart] = useState(false);

    const { discounts = [], is_available: isAvailable = false } = product;

    const showModalMessage = (message, { success = false, alreadyInCart = false } = {}) => {
        setModalMessage(message);
        setIsSuccessMessage(success);
        setIsAlreadyInCart(alreadyInCart);
        setShowModal(true);
    };

    const handleBuyClick = async () => {
        if (!user) {
            showModalMessage("Чтобы добавить товар в корзину, необходимо войти в профиль.");
            return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
            showModalMessage("Токен не найден. Пожалуйста, войдите заново.");
            return;
        }

        try {
            const response = await fetch(
                `${AppProps.spring_server_url}/shopping-cart?product=${product.id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const errorText = await response.text();

            if (response.ok) {
                showModalMessage("Товар успешно добавлен в корзину!", { success: true });
            } else if (
                response.status === 409 ||
                errorText.toLowerCase().includes("already exists")
            ) {
                showModalMessage("Этот товар уже есть в корзине.", { alreadyInCart: true });
            } else {
                showModalMessage(errorText || "Ошибка при добавлении товара в корзину.");
            }
        } catch (error) {
            console.error("Ошибка при добавлении товара в корзину:", error);
            showModalMessage("Произошла ошибка. Пожалуйста, попробуйте позже.");
        }
    };

    const renderPrice = () => {
        if (discounts.length) {
            const discountedPrice = product.price - discounts[0].amount;
            return (
                <>
                    <strong style={{ textDecoration: "line-through", color: "black" }}>
                        {product.price.toLocaleString()} ₽
                    </strong>{" "}
                    <strong style={{ color: "white" }}>
                        {discountedPrice.toLocaleString()} ₽/месяц
                    </strong>
                </>
            );
        }
        return <strong>от {product.price.toLocaleString()} ₽</strong>;
    };

    return (
        <>
            <div className="item features-without-image col-12 col-md-6 col-lg-6 item-mb">
                <div className="item-wrapper">
                    <div className="item-head">
                        <h5 className="item-title mbr-fonts-style mb-0 display-5">
                            <strong>{product.full_name}</strong>
                        </h5>
                        <h6 className="item-subtitle mbr-fonts-style mb-0 display-7">
                            {product.subcategory && <em><strong>{product.subcategory}</strong></em>}
                            <br />
                            {renderPrice()}
                        </h6>
                    </div>

                    <div className="item-content">
                        <p className="mbr-text mbr-fonts-style display-7">{product.description}</p>

                        {product.layers?.length > 0 && (
                            <>
                                <button
                                    onClick={() => setShowLayers(prev => !prev)}
                                    className="btn btn-sm btn btn-danger-outline display-4 mt-2"
                                >
                                    {showLayers ? "Скрыть слои" : "Показать слои"}
                                </button>

                                {showLayers && (
                                    <ul className="mt-3" style={{ paddingLeft: 20 }}>
                                        {product.layers.map((layer, index) => (
                                            <li key={layer.id || index} className="mbr-fonts-style display-7 mb-2">
                                                <strong>{layer.full_name}</strong>

                                                {layer.features?.length > 0 && (
                                                    <ul style={{ marginTop: 4, paddingLeft: 20 }}>
                                                        {layer.features.map((feature) => (
                                                            <li key={feature.id} className="text-muted">
                                                                {feature.located_name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        )}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {isAvailable ? (
                            <button
                                onClick={handleBuyClick}
                                className="btn item-btn btn-danger display-7 mb-0"
                            >
                                Купить
                            </button>
                        ) : (
                            <button
                                onClick={() => navigate(`/product/${product.id}`)}
                                className="btn btn-danger-outline display-4 mb-0"
                            >
                                Узнать больше
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showModal && (
                <div
                    className="modal-overlay"
                    onClick={() => setShowModal(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1050,
                    }}
                >
                    <div
                        className="card p-4"
                        onClick={e => e.stopPropagation()}
                        style={{
                            maxWidth: 400,
                            width: "90%",
                            backgroundColor: "white",
                            textAlign: "center",
                        }}
                    >
                        <h3
                            className={`mb-3 item-title mbr-fonts-style mb-0 display-5 ${
                                isSuccessMessage ? "text-danger" : "text-danger"
                            }`}
                            style={{ textAlign: "center" }}
                        >
                            {isSuccessMessage ? "Успешно" : "Ошибка"}
                        </h3>

                        <p className="mbr-fonts-style display-7">{modalMessage}</p>

                        {!isSuccessMessage && !isAlreadyInCart && (
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    navigate("/login"); // или ссылка на страницу входа
                                }}
                                className="btn btn-danger w-100 mb-2"
                            >
                                Войти в профиль
                            </button>
                        )}

                        <button
                            onClick={() => setShowModal(false)}
                            className={`btn w-100 ${isSuccessMessage ? "btn-danger" : "btn-danger-outline"}`}
                        >
                            Ок
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProductsBased;
